module.exports = __webpack_public_path__ + "img/amara_logo_white.312510f5.png";